export const STATIC_URL = '//lion-dex-static.pages.dev/image/'
